// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09b603c0","239":"6a7c86a5","455":"fd7fa64c"}[chunkId] + ".chunk.js";
};